import { BetInterface } from '../interface/betInterface/betInterface.class'
import { Button }       from './button.class'
import { Click }        from '../click/click.class'
import { arch, hidden } from '../../sass/button/arch/button.arch.class.scss'
import { IS_IE }        from '../../constants/isIE/is-ie.constant'
import { ORIENTATION }    from '../../constants/orientation/orientation.constant'

/**
 * @file Defines the {@link BetButton} class.
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /**
  * Class for handling bet button
  * @extends Button
  */
 export class BetButton extends Button {

    /**
     * Reference to bet interface
     * @memberof BetButton
     * @protected
     * @instance
     * @type {BetInterface}
     */
    _interface

    /**
     * Initialise core button properties
     * @param {string[]} assets_  - Array of data URIs containing button assets.
     * @param {string}   id_      - ID of button.
     * @param {string[]} states_  - Array of possible button states.
     * @param {boolean}  visible_ - Whether button is initially visible.
     * @param {boolean}  text_    - Whether button has text.
     * @param {function} click_   - Object containg click events for each state.
     */
    constructor(assets_, id_, states_, visible_, text_, click_ = null) {

        super(assets_, id_, states_, visible_, text_) //Call parent constructor

        //If mobile
        if (framework.isTouch()) {

            this._interface = new BetInterface()    //Create bet interface
            new Click(this._elem, this.click, this) //Add click handler
                            
            this._div = document.createElement('div') //Create div element
            this._div.classList.add(this.id, 'button__container')

            this._div.appendChild(this._elem)
            this._div.appendChild(this._textElem)
            
            this.addToWrapper()

        }

        //Desktop
        else {

            //If button has click handler
            if (this.click !== null) {
                new Click(this.elem, click_, this) //Add click handler
            }

            //If button has text
            if (text_) {

                //Loop through buttons children nodes
                for (let i = 0; i < this.elem.children.length; i++) {

                    let c = this.elem.children[i] //Store child node

                    //If text node found
                    if (c.className === 'bet__amount') {
                        this._textElem = c //Store reference to button text element
                    }

                }

            }

        }

    }

    /** Get interface */ get interface() { return this._interface }
    /** Get text */      get text()      { return this._text }

    /**
     * Click handler for bet
     * @param {object} this_ - Reference to class's scope
     */
    click(this_) {

        let _this = this_ //Store reference to scope

        document.getElementById(arch).classList.add(hidden) //Hide portrait arch
        _this._interface.show = true                        //Toggle bet interface
        _this._interface.render()                           //Render bet interface

    }

    /** Set text */ 
    set text(v_) { 

        let digits = v_.match(/\d+/g).join('') //Retrieve length of digits from currency value

        //If digits is in the millions
        if (digits.length > 6) {

            //If IE/Edge browser
            if (IS_IE) {

                //Apply styling to prevent text overlapping boundary
                this.textElem.style.padding     = '5px'
                this.textElem.style.paddingLeft = '20px'

            }

            //Any other half decent browser
            else {
                this.textElem.style.padding = '5px' //Apply styling to prevent text overlapping boundary    
            }

            
        }

        this._text = v_ //Update text field

        this.textElem.innerHTML = this._text //Update button text

    }
     
    /** Set enable */
    set enable(v_) {

        this._enable = v_
        this.elem.disabled = !this._enable
        
        // If button is disabled, add disable_pointer class to prevent pointer events
        this._enable ? this.elem.classList.remove('disable_pointer') : this.elem.classList.add('disable_pointer')

        // Get element to apply styling to
        let element = this._div ? this.elem : this.elem.children[0]
        
        // If button is disabled, add disabled class to apply styling
        this._enable ? element.classList.remove('disabled') : element.classList.add('disabled')
        
        this.backgroundImage()

    }
     
    /** Get enable (needs to be overridden since setter was overridden) */
    get enable() { return this._enable }
     
    /** Get visible */
    get visible() { return this._visible }
     
    /** Set visible */
    set visible(v_) {
        this._visible = v_
        var element = this._div ? this._div : this._elem
        this._visible ? element.classList.remove(hidden) : element.classList.add(hidden)
        
    }
     
    /**
     * Adds button to correct parent based on orientation
     */
    addToWrapper() {
        //Add button and text to correct parent based on orientation
        var parent = ORIENTATION.orientation === 'landscape' ? document.getElementById(this._layout) : document.getElementById('arch')
        
        if (this._div) {
            parent.appendChild(this._div)
            return
        }
        
        parent.appendChild(this._elem)
        parent.appendChild(this._textElem)
    }
 
 }